import DashboardIcon from 'modules/Nav/icons/DashboardIcon'
import RolesIcon from 'modules/Nav/icons/RolesIcon'
import UsersIcon from 'modules/Nav/icons/UsersIcon'
import Speed from 'modules/Nav/icons/SpeedIcon'
import MandatesIcon from 'modules/Nav/icons/MandatesIcon'

import SettingsIcon from 'modules/Nav/icons/SettingsIcon'

export const navItems = [
  // {
  //   path: '/dashboard',
  //   icon: DashboardIcon,
  //   navTitle: 'Dashboard',
  //   pageTitle: 'Dashboard',
  //   menuType: 'GlobalMenu',
  // },
  {
  path: '/dashboard',
  icon: DashboardIcon,
  navTitle: 'dashboard',
  pageTitle: 'Dashboard',
  menuType: 'GlobalMenu',
},
  {
    // Assessment dashboard. Two independent gates, both required:
    //
    //   requiresFeature — the corporate must actually have the Assessment
    //     product. Read at runtime from corporate-node's feature-access
    //     endpoint, which derives it from corporates.accessLevel (2 or 3) —
    //     the same value admin sets in the ASSMT. column of Feature Access.
    //     Fails CLOSED: if the flag cannot be read the item stays hidden,
    //     because showing a paid product to an account without it is the
    //     worse failure.
    //
    //   CORPORATE_V2_ASSESSMENTS_ENABLED — whether THIS environment runs
    //     corporate-react-v2. Deliberately separate from the Roles flag: an
    //     env can have the v2 assessment screens without Roles being there,
    //     and one flag governing both is what previously dragged Roles into
    //     v2 by accident. Unset falls back to the legacy v1 screen, which is
    //     the safe direction — an env without v2 serves the v1 SPA for
    //     /v2/*, answers HTTP 200 and renders PageNotFound, so a dead nav
    //     item there is invisible to every health check.
    // Lands on the v2 DASHBOARD, not the assessments list: the dashboard is the
    // overview a recruiter wants first, and the list is one click away in the
    // v2 sidebar. The legacy fallback stays the v1 list, which is all that
    // environment has.
    path:
      process.env.CORPORATE_V2_ASSESSMENTS_ENABLED === 'true'
        ? '/v2/dashboard'
        : '/assessments',
    icon: Speed,
    navTitle: 'Assessments',
    pageTitle: 'Assessments',
    menuType: 'GlobalMenu',
    requiresFeature: 'ASSESSMENT',
  },
  {
    path: '/interviewerDashboard',
    icon: DashboardIcon,
    navTitle: 'Interviewer Dashboard',
    pageTitle: 'Interviewer Dashboard',
    menuType: 'GlobalMenu',
  },

  {
    // Strangler-fig: Roles is migrated to corporate-react-v2, served same-origin
    // under /v2 (Nav's onItemClick hard-navigates for any /v2/* path).
    //
    // Which target is correct depends on the ENVIRONMENT, not on the branch —
    // an env where corporate-react-v2 is not deployed must keep the legacy
    // screen, because nginx there has only `location /` and /v2/roles would be
    // served the v1 SPA, which answers HTTP 200 and then renders PageNotFound.
    // A dead nav item behind a 200 is invisible to every health check.
    //
    // So this reads a flag from that environment's own env file instead of
    // being hand-edited per branch. It was edited-and-reverted twice before
    // this, and a release cut from UAT silently dropped it once.
    //
    // Unset => legacy Roles. Defaulting to the old screen is the safe direction:
    // the worst case is a stale UI, not an unreachable one.
    // Roles is served by v1 again. corporate-react-v2 still CONTAINS the Roles
    // screens, but its own sidebar now bridges back here, so this must point at
    // the v1 screen too — otherwise the two sidebars point at each other and a
    // recruiter sent from here is immediately invited back by the app they land
    // in. Both ends were changed together; do not flip one without the other.
    path: '/rolePage',
    icon: RolesIcon,
    navTitle: 'Roles',
    pageTitle: 'Roles',
    menuType: 'GlobalMenu',
  },
  // {
  //   path: '/rolePage',
  //   icon: RolesIcon,
  //   navTitle: 'Role Page',
  //   pageTitle: 'Role Page',
  //   menuType: 'GlobalMenu',
  // },
  {
    path: '/users',
    icon: UsersIcon,
    navTitle: 'Users',
    pageTitle: 'Users',
    menuType: 'GlobalMenu',
  },
  {
    path: '/mandates',
    icon: MandatesIcon,
    navTitle: 'Mandates',
    pageTitle: 'Hiring Mandates',
    menuType: 'GlobalMenu',
  },
  {
    path: '/reports',
    icon: Speed,
    navTitle: 'Reports',
    pageTitle: 'Reports',
    menuType: 'GlobalMenu',
    externalMenu: [
      {
        path: '/reports/role/published',
        icon: RolesIcon,
        navTitle: 'Roles Published to Colleges',
        pageTitle: 'Roles Published to Colleges',
        menuType: 'externalMenu',
      },
      // {
      //   path: '/reports/application/status',
      //   icon: RolesIcon,
      //   navTitle: 'Candidate Application Status',
      //   pageTitle: 'Candidate Application Status',
      //   menuType: 'externalMenu',
      // },
      // {
      //   path: '/reports/drive/level',
      //   icon: RolesIcon,
      //   navTitle: 'Applicants at Drive level',
      //   pageTitle: 'Applicants at Drive level',
      //   menuType: 'externalMenu',
      // },
      // {
      //   path: '/reports/hiring/status',
      //   icon: RolesIcon,
      //   navTitle: 'Hiring Status',
      //   pageTitle: 'Hiring Status',
      //   menuType: 'externalMenu',
      // },
      // {
      //   path: '/reports/interview/schedule',
      //   icon: RolesIcon,
      //   navTitle: 'Interview Schedule',
      //   pageTitle: 'Interview Schedule',
      //   menuType: 'externalMenu',
      // },
    ],
  },
  {
    path: '/settings',
    icon: SettingsIcon,
    navTitle: 'Settings',
    pageTitle: 'Settings',
    menuType: 'GlobalMenu',
  },
  {
    path: '/activity-log',
    icon: SettingsIcon,
    navTitle: 'Activity Log',
    pageTitle: 'Activity Log',
    menuType: 'GlobalMenu',
  },
]
